import ProxyBase from '../ProxyBase';
import ServiceProxyConfig from '../../../configs/ServiceProxyConfig';

class UserSettingProxy extends ProxyBase {
  getUserSettings(data) {
    return this.get('GetUserSettings', data);
  }

  updateUserSettings(data) {
    return this.post('UpdateUserSettings', data);
  }

  getUserWatchList(data, source) {
    return this.get('GetUserWatchList', data, source);
  }

  newWatchList(data) {
    return this.post('NewWatchList', data);
  }

  deleteWatchList(data, source) {
    return this.post('DeleteWatchList', data, source);
  }

  updateWatchList(data, source) {
    return this.post('UpdateWatchList', data, source);
  }

  renameWatchList(data, source) {
    return this.post('RenameWatchList', data, source);
  }

  newWorkspace(data) {
    return this.post('NewWorkspace', data);
  }

  getWorkspace(data) {
    return this.get('GetWorkspace', data);
  }

  updateWorkspace(data) {
    return this.post('UpdateWorkspace', data);
  }

  deleteWorkspace(data) {
    return this.post('DeleteWorkspace', data);
  }

  getScreeners(data) {
    return this.get('GetScreeners', data);
  }

  getTopScreeners(data) {
    return this.get('getTopScreeners', data);
  }

  createScreener(data) {
    return this.post('CreateScreener', data);
  }

  deleteScreener(data) {
    return this.post('DeleteScreener', data);
  }

  updateScreener(data) {
    return this.post('UpdateScreener', data);
  }

  createChartLayout(data) {
    return this.post('CreateChartlayout', data);
  }

  updateChartLayout(data) {
    return this.post('UpdateChartLayout', data);
  }

  getChartLayouts(params) {
    return this.get('GetChartLayouts', params);
  }

  deleteChartLayout(params) {
    return this.post('DeleteChartLayout', params);
  }

  getChartLayoutShareInfo(params) {
    return this.post('GetChartLayoutShareInfo', params);
  }

  getChangeLogs(params) {
    return this.get('GetChangeLogs', params);
  }

  getChangeLogsV3(params) {
    return this.get('GetChangeLogsV3', params);
  }

  appendTickerToWatchlist(params) {
    return this.post('AppendTickerToWatchList', params);
  }
}

const userSettingProxy = new UserSettingProxy(
  ServiceProxyConfig.Common.UserSetting.ServiceUrl,
);
export default userSettingProxy;
